import { TEACHER_ROUTE } from 'app/teacher/routing-constants/teacher-routing.constant';

export const STUDENT_SUMMARY_ROUTE = {
  name: 'studentsummary/:studentId',
  route(classId: string, studentId: string): string[] {
    return [...TEACHER_ROUTE.ACTIVE_CLASS.route(classId), 'studentsummary', studentId];
  }
};
